module.exports = "../dist/img/upper-banner-42.864d.jpg";